/**
 *
 * Styles for ModalError
 *
 */

import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { DhlText } from "@dhl-official/react-library";

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const ContentFreightP2PModal = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: left;
  margin: var(--gaq-size-space-50px) var(--dui-size-space-0)
    var(--gaq-size-space-50px) var(--dui-size-space-0);

  h2 {
    margin-bottom: 0;
  }

  div {
    margin-bottom: var(--dui-size-space-10x);
  }

  .subheading {
    font-size: var(--dui-size-font-3xl);
    line-height: var(--dui-size-line-height-10xl);
    font-weight: 300;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin: var(--dui-size-space-20x) var(--dui-size-space-0)
      var(--gaq-size-space-50px) var(--dui-size-space-0);

    & {
      flex-direction: row;
      text-align: left;
    }

    div {
      margin-bottom: 0;

      &:first-child {
        padding-right: var(--dui-size-space-10x);
      }
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      margin: var(--dui-size-space-10x) 0 var(--gaq-size-space-30px) 0;
    }
  }
`;

export const CopyContainer = styled.div`
  text-align: center;
  margin: var(--dui-size-space-10x) auto 0;

  @media screen and (min-width: ${breakpoints.tablet}) {
    p {
      margin-top: 0;
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin-top: var(--gaq-size-space-30px);

  @media screen and (min-width: ${breakpoints.tablet}) {
    max-width: 60%;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const LinkWrapper = styled.span`
  display: block;
`;

export const OrWraper = styled.div`
  margin: var(--dui-size-space-5x) 0 var(--gaq-size-space-5px);
`;

export const TextInfo = styled(DhlText)`
  display: block;
  & > *:is(p, span) {
    margin-bottom: ${(props) =>
      props.doubleBottomSpacing ? "var(--dui-size-space-10x)" : 0};
  }
`;
